import { useCallback, useEffect, useState } from "react";

const FAVORITE_KEY = "hlwc:favorites";

function readIds(key: string): number[] {
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.map((value) => Number(value)).filter((value) => Number.isFinite(value));
  } catch {
    return [];
  }
}

function writeIds(key: string, ids: number[]) {
  try {
    window.localStorage.setItem(key, JSON.stringify(ids));
  } catch {
    // 忽略隐私模式下的写入失败
  }
}

export function useFavorites() {
  const [favorites, setFavorites] = useState<number[]>([]);

  useEffect(() => {
    setFavorites(readIds(FAVORITE_KEY));
  }, []);

  const toggle = useCallback((id: number) => {
    setFavorites((prev) => {
      const next = prev.includes(id) ? prev.filter((item) => item !== id) : [id, ...prev];
      writeIds(FAVORITE_KEY, next);
      return next;
    });
  }, []);

  const isFavorite = useCallback((id: number) => favorites.includes(id), [favorites]);

  return { favorites, toggle, isFavorite };
}

const RECENT_KEY = "hlwc:recent";
const RECENT_LIMIT = 5;

export function useRecentlyViewed() {
  const [recent, setRecent] = useState<number[]>([]);

  useEffect(() => {
    setRecent(readIds(RECENT_KEY));
  }, []);

  const track = useCallback((id: number) => {
    setRecent((prev) => {
      const next = [id, ...prev.filter((item) => item !== id)].slice(0, RECENT_LIMIT);
      writeIds(RECENT_KEY, next);
      return next;
    });
  }, []);

  return { recent, track };
}

export function useRecentList() {
  const [recent, setRecent] = useState<number[]>([]);
  useEffect(() => {
    setRecent(readIds(RECENT_KEY));
  }, []);
  return recent;
}